import { FC, ReactNode } from "react";
import useAuth from "src/hooks/useAuth/useAuth";
import { isAdmin, isSuperUser } from "src/utils/admin";

interface Props {
	children?: ReactNode;
	specificGroup?: any;
}

const UserAdminFilter: FC<Props> = ({ children, specificGroup }) => {
	const { userRoles } = useAuth();

	const render = () => {

		if(specificGroup) {
			if(!userRoles.includes(specificGroup))
				return  null;
			else 
				return children;
		}

		if (isSuperUser(userRoles)) return children;
		if (isAdmin(userRoles)) return children;

		return null;
	};

	return <>{render()}</>;
};

export default UserAdminFilter;
